
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MdsIcon, MdsIconsModule } from '@mds/icons';

@Component({
  selector: 'app-pef-score',
  templateUrl: './pef-score.component.html',
  styleUrls: ['./pef-score.component.scss'],
  standalone: true,
  imports: [MatCardModule, MdsIconsModule]
})
export class PefScoreComponent {
  icons = MdsIcon;
  @Input() score: string;
}
